import { NgModule } from '@angular/core';
import { MwPerfectScrollBarDirective } from './perfect-scrollbar.directive';
import { MwEllipsisDirective } from './ellipsis.directive';
import { MwTimeValueDirective } from './use-value-as-time.directive';
import { MwDateValueDirective } from './use-value-as-date.directive';

@NgModule({
  declarations: [
    MwPerfectScrollBarDirective,
    MwEllipsisDirective,
    MwDateValueDirective,
    MwTimeValueDirective,
  ],
  imports: [],
  exports: [
    MwPerfectScrollBarDirective,
    MwEllipsisDirective,
    MwDateValueDirective,
    MwTimeValueDirective,
  ],
})
export class MwDirectivesModule {}
